import React, { FC } from "react";
import { useSelector } from "react-redux";

import { useInvoiceCurrencies } from "../../../hooks/useInvoiceCurrencies";
import { selectInvoice } from "../../../store/reducers/invoice";
import { formatAmount } from "../../../utils/numbers/money";

export const TotalSumToPay: FC = () => {
  const invoice = useSelector(selectInvoice);
  const invoiceCurrencies = useInvoiceCurrencies(invoice);
  const inputCurrencySymbol = invoiceCurrencies?.input?.symbol;
  const incomigCurrencySymbol = invoiceCurrencies?.incoming?.symbol;

  if (!invoice) {
    return <></>;
  }

  const {
    amount,
    items_amounts_are_in_outgoing_currency,
    transaction_details,
  } = invoice;

  return (
    <div className="flex flex-col">
      <div className="flex justify-between items-center border-y py-2">
        <div>Total sum to pay</div>
        <div className="flex flex-col items-end">
          <div className="text-2xl">
            {formatAmount(amount)} {inputCurrencySymbol}
          </div>

          {items_amounts_are_in_outgoing_currency && (
            <div className="">
              {formatAmount(transaction_details?.amount || 0)}
              {incomigCurrencySymbol}
            </div>
          )}
        </div>
      </div>

      {items_amounts_are_in_outgoing_currency ? (
        <div className="text-sm pt-2">
          Payout amount in USDT is fixed.{" "}
          <a
            className="font-extrabold"
            href="https://archway.finance/terms-of-service"
          >
            See Terms of Service
          </a>
        </div>
      ) : (
        <div className="theme-text-secondary text-sm pt-2">
          We'll send the crypto at the current exchange rate on the day we
          receive the bank payment
        </div>
      )}
    </div>
  );
};
